import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login' // Redirige la ruta raíz a la página de inicio de sesión
  },
  {
    path: '/login/:language?',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: { public: true }
  },
  {
    path: '/formulario/:agencia/:camino/:language',
    name: 'formularioWeb',
    component: () => import('../views/FormularioWeb.vue'),
    meta: { public: true }
  },
  {
    path: '/formulario_inicial',
    name: 'formularioInicial',
    component: () => import('../views/FormularioInicial.vue'),
    meta: { public: false }
  },
  {
    path: '/central_agencias/:agencia',
    name: 'central_agencias',
    component: () => import('../views/CentralAgencias.vue'),
    meta: { public: false }
  },
  {
    path: '/central_reservas/:admin/:agencia/:camino_id/:language',
    name: 'central_reservas',
    component: () => import('../views/CentralReservas.vue'),
    meta: { public: false }
  },
  {
    path: '/central_reservas/ext/:agencia/:language?',
    name: 'central_reservas_ext',
    component: () => import('../views/CentralReservas.vue'),
    meta: { public: false }
  },
  {
    path: '/confirmacion_presupuesto/:language/:hash',
    name: 'confirmacionPresupuesto',
    component: () => import('../views/ConfirmacionPresupuesto.vue'),
    meta: { public: true }
  },
  {
    path: '/registro_viajero/:language/:hash',
    name: 'registroViajero',
    component: () => import('../views/RegistroViajero.vue'),
    meta: { public: true }
  },
  {
    path: '/registro_viajeros/:language/:hash',
    name: 'registroViajeros',
    component: () => import('../views/RegistroViajeros.vue'),
    meta: { public: true }
  },
  {
    path: '/cuestionario/:hash',
    name: 'cuestionario',
    component: () => import('../views/Cuestionario.vue'),
    meta: { public: true }
  },
  {
    path: '/registro_viajeros_agencia/:language/:hash',
    name: 'registroViajerosAgencia',
    component: () => import('../views/RegistroViajerosAgencia.vue'),
    meta: { public: true }
  },
  {
    path: '/autorizacion_tarjeta_pasajero/:language/:hash',
    name: 'autorizacionTarjetaPasajero',
    component: () => import('../views/AutorizacionTarjeta.vue'),
    meta: { public: true }
  },
  {
    path: '/autorizacion_tarjeta/:language/:hash',
    name: 'autorizacionTarjeta',
    component: () => import('../views/AutorizacionTarjeta.vue'),
    meta: { public: true }
  },
  {
    path: '/disponibilidad/:hash/:accion',
    name: 'disponibilidad',
    component: () => import('../views/Disponibilidad.vue'),
    meta: { public: true }
  },
  {
    path: '/consultar_agencia/:language/:hash',
    name: 'consultarAgenciaPresupuesto',
    component: () => import('../views/ConsultarAgenciaPresupuesto.vue'),
    meta: { public: false }
  },
  {
    path: '/activar-credencial-agencia/:hash',
    name: 'activarCredencialAgencia',
    component: () => import('../views/ActivarCredencialAgencia.vue'),
    meta: { public: true }
  },

  {
    path: '/:language/success',
    name: 'success',
    component: () => import('../views/Success.vue'),
    meta: { public: true }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});



router.beforeEach((to, from, next) => {
 
  const isAuthenticated = store.state.auth.isLogged; // Verifica si el usuario está autenticado
  
  if (to.matched.some(record => record.meta.public)) {
    next()
    return
  }

  //console.log('ambas', to.matched.some(record => record.meta.public) && !isAuthenticated);

  if (!to.matched.some(record => record.meta.public) && !isAuthenticated) {
    //console.log('ruta no publica y no autenticada', to);
    next('/login')
    return
  }

  next()
  
  
});



export default router
